import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaEnvelope, FaArrowRight } from 'react-icons/fa';
import { getBrand } from '../utils/brandStyles';

const Footer = ({ market, content }) => {
  const b = getBrand(market);
  return b.isMWO
    ? <MWOFooter b={b} content={content} />
    : <MinditFooter b={b} market={market} content={content} />;
};

/* ─── MWO Footer ─────────────────────────────────────────── */
const MWOFooter = ({ b, content }) => {
  const serviceLinks = [
    { name: 'IT Consulting',     path: '/services/consulting' },
    { name: 'Managed IT',        path: '/services/managed-it' },
    { name: 'Cloud Solutions',   path: '/services/cloud' },
    { name: 'Cybersecurity',     path: '/services/security' },
    { name: 'AI & Automation',   path: '/services/ai-consulting' },
    { name: 'Small Business IT', path: '/services/small-business' }
  ];

  const labelStyle = {
    fontFamily: b.fontDisplay,
    fontWeight: 700,
    fontSize: 'var(--ds-fz-footer-label, 12px)',
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
    color: '#00BCD4',
    marginBottom: '24px'
  };

  const linkStyle = {
    fontSize: 'var(--ds-fz-footer-link, 15px)',
    color: 'rgba(244,241,235,0.65)',
    fontFamily: b.fontBody
  };

  return (
    <footer style={{ background: '#090B0F', color: '#F4F1EB', fontFamily: b.fontBody }}>
      <div style={{ borderTop: '2px solid #00BCD4' }} />

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '72px clamp(24px, 6vw, 80px) 48px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '48px', marginBottom: '64px' }}>

          {/* Brand column */}
          <div>
            <Link to="/" style={{ textDecoration: 'none', display: 'block', marginBottom: '24px' }}>
              <img src={content.logo} alt={content.logoAlt} style={{ height: '48px', width: 'auto' }} />
            </Link>
            <p style={{ fontSize: 'var(--ds-fz-footer-body, 0.93rem)', lineHeight: 1.8, color: 'rgba(244,241,235,0.7)', maxWidth: '260px', marginBottom: '28px' }}>
              Expert IT operations for growing businesses worldwide.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a href={`mailto:${content.email}`} aria-label="Email" style={{ color: 'rgba(244,241,235,0.62)', transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#00BCD4'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(244,241,235,0.62)'}>
                <FaEnvelope size={18} />
              </a>
              <a href={content.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"
                style={{ color: 'rgba(244,241,235,0.62)', transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#00BCD4'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(244,241,235,0.62)'}>
                <FaLinkedin size={18} />
              </a>
            </div>
          </div>

          {/* Services column */}
          <div>
            <h4 style={labelStyle}>Services</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {serviceLinks.map((item, idx) => (
                <li key={idx}>
                  <Link to={item.path} className="footer-link" style={linkStyle}>{item.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company column */}
          <div>
            <h4 style={labelStyle}>Company</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                { name: 'Home',     path: '/' },
                { name: 'About',    path: '/about' },
                { name: 'Insights', path: '/insights' },
                { name: 'Contact',  path: '/contact' }
              ].map((item, idx) => (
                <li key={idx}>
                  <Link to={item.path} className="footer-link" style={linkStyle}>{item.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact column */}
          <div>
            <h4 style={labelStyle}>Get In Touch</h4>
            <a
              href={`mailto:${content.email}`}
              style={{
                fontFamily: b.fontBody,
                fontWeight: 600,
                fontSize: 'var(--ds-fz-footer-link, 15px)',
                color: 'rgba(244,241,235,0.7)',
                textDecoration: 'none',
                display: 'block',
                marginBottom: '20px',
                transition: 'color 0.2s'
              }}
              onMouseEnter={e => e.currentTarget.style.color = '#00BCD4'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(244,241,235,0.7)'}
            >
              {content.email}
            </a>
            <Link to="/contact" className="btn-primary-mwo" style={{ padding: '11px 26px' }}>
              Schedule a Call <FaArrowRight size={10} style={{ marginLeft: '6px' }} />
            </Link>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.07)',
          paddingTop: '28px',
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', flexWrap: 'wrap', gap: '12px'
        }}>
          <p style={{
            fontFamily: b.fontDisplay,
            fontSize: 'var(--ds-fz-footer-label, 12px)',
            color: 'rgba(244,241,235,0.35)',
            letterSpacing: '0.06em',
            textTransform: 'uppercase'
          }}>
            &copy; {new Date().getFullYear()} {content.companyName}. All rights reserved.
          </p>
          <p style={{
            fontFamily: b.fontDisplay,
            fontSize: 'var(--ds-fz-footer-label, 12px)',
            color: 'rgba(244,241,235,0.25)',
            letterSpacing: '0.06em',
            textTransform: 'uppercase'
          }}>
            {content.location}
          </p>
        </div>
      </div>
    </footer>
  );
};

/* ─── Mind IT Footer ──────────────────────────────────────── */
const MinditFooter = ({ b, market, content }) => {
  const serviceLinks = market === 'lu' ? [
    { name: 'Cloud Migration', path: '/services/cloud' },
    { name: 'AI Consulting',   path: '/services/ai-consulting' },
    { name: 'Managed IT',      path: '/services/managed-it' },
    { name: 'Cybersecurity',   path: '/services/security' }
  ] : [
    { name: 'IT Consulting',   path: '/services/consulting' },
    { name: 'Managed IT',      path: '/services/managed-it' },
    { name: 'Cloud Solutions', path: '/services/cloud' },
    { name: 'Cybersecurity',   path: '/services/security' }
  ];

  const labelStyle = {
    fontSize: 'var(--ds-fz-footer-label, 12px)',
    fontWeight: 700,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#00BCD4',
    marginBottom: '18px',
    fontFamily: b.fontBody
  };

  const linkStyle = {
    fontSize: 'var(--ds-fz-footer-link, 15px)',
    color: 'rgba(255,255,255,0.7)',
    fontFamily: b.fontBody
  };

  return (
    <footer style={{ backgroundColor: '#0F1B45', color: 'white', padding: '56px clamp(24px, 6vw, 80px) 32px', fontFamily: b.fontBody }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}>
          {/* Company info */}
          <div>
            <h3 style={{
              fontFamily: b.fontDisplay,
              fontSize: '1.3rem',
              marginBottom: '14px',
              color: '#fff'
            }}>{content.companyName}</h3>
            <p style={{ fontSize: 'var(--ds-fz-footer-body, 0.93rem)', lineHeight: 1.7, color: 'rgba(255,255,255,0.6)', marginBottom: '16px' }}>
              {market === 'lu'
                ? 'Expert IT solutions for Luxembourg small businesses. Fast, reliable, and tailored to your needs.'
                : 'Innovative IT services and advisory for businesses worldwide since 2013.'}
            </p>
            {market === 'lu' && (
              <p style={{ fontSize: 'var(--ds-fz-footer-body, 0.93rem)', color: '#00BCD4', fontWeight: 600 }}>Launching March 2026</p>
            )}
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={labelStyle}>Quick Links</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                { name: 'Home',     path: '/' },
                { name: 'About',    path: '/about' },
                { name: 'Insights', path: '/insights' },
                { name: 'Contact',  path: '/contact' },
                ...(market === 'lu' ? [{ name: 'Free Assessment', path: '/services/assessment' }] : [])
              ].map((item, idx) => (
                <li key={idx}>
                  <Link to={item.path} className="footer-link" style={linkStyle}>{item.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 style={labelStyle}>Services</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {serviceLinks.map((item, idx) => (
                <li key={idx}>
                  <Link to={item.path} className="footer-link" style={linkStyle}>{item.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={labelStyle}>Contact</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <FaEnvelope size={14} color="#00BCD4" />
                <a href={`mailto:${content.email}`} className="footer-link" style={linkStyle}>{content.email}</a>
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <FaLinkedin size={14} color="#00BCD4" />
                <a href={content.linkedin} target="_blank" rel="noopener noreferrer" className="footer-link" style={linkStyle}>
                  LinkedIn
                </a>
              </li>
            </ul>
            <p style={{ fontSize: 'var(--ds-fz-footer-body, 0.93rem)', marginTop: '16px', color: 'rgba(255,255,255,0.45)' }}>
              {content.location}
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.1)',
          paddingTop: '24px',
          textAlign: 'center',
          fontSize: 'var(--ds-fz-footer-body, 0.93rem)',
          color: 'rgba(255,255,255,0.45)'
        }}>
          <p>&copy; {new Date().getFullYear()} {content.companyName}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
